import { getInjection } from '@/di/inversify.config';
import { Result } from '@/entities/Result';
import { TeamLeagueAddPlayerResponse } from '@/infrastructure/network/dto/TeamLeagueAddPlayerDto';

export const tradePlayersUseCase = async (
	organizationUuid: string,
	teamLeagueUuid: string,
	teamUuid: string,
	playersLeavingTeam: string[],
	playersJoiningTeam: string[],
	receivingTeamUuid: string
): Promise<Result<TeamLeagueAddPlayerResponse>> => {
	const teamLeaguePlayersRepository = getInjection('ITeamLeaguePlayersRepository');
	return teamLeaguePlayersRepository.tradePlayers(
		organizationUuid,
		teamLeagueUuid,
		teamUuid,
		playersLeavingTeam,
		playersJoiningTeam,
		receivingTeamUuid
	);
};
